<template>
    <div class="stat-list">
      <h3>{{ $t('randevu.stats.top_services.title') }} <span style="font-size: 0.8em;">{{ $t('randevu.stats.top_services.subtitle') }}</span></h3>
      <div v-if="services && services.length > 0">
        <div v-for="s in services" :key="s.service_id" class="service-item">
          <span class="service-name">{{ s.service_name }}</span>
          <span class="service-count">{{ s.total }} {{ $t('randevu.stats.top_services.count_suffix') }}</span>
        </div>
      </div>
      <p v-else-if="services === null">{{ $t('common.loading') }}</p>
      <p style="color: #917e5c ;" v-else>{{ $t('randevu.stats.top_services.empty') }}</p>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
    name: 'TopServicesList',
    data() { return { services: null }; },
    async created() {
      try {
        const { data } = await axios.get('/promo/user/stats/top-services?limit=10');
        this.services = data.length ? data : [];  
      } catch (err) { 
        console.error('Veri alınamadı:', err); 
        this.services = []; 
      }
    }
  };
  </script>
  
  <style scoped>
  .stat-list {
    padding: 1rem;
    background-color: #050505; 
    border-radius: 6px;
    margin-top: 1em;
  }
  
  h3 {
    margin-bottom: 0.5rem;
    font-size: 1rem; 
    font-weight: 400;
  }
  
  .service-item {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0;
    border-bottom: 1px solid #444;
  }
  
  .service-name {
    font-weight: bold;
  }
  
  .service-count {
    font-style: italic; 
  }
  </style>
  